
























import { Component, Vue } from 'vue-property-decorator';

@Component
export class App extends Vue {
    private toSearch() {
        if ( this.$router.currentRoute.fullPath !== '/') {
          this.$router.push('/');
        }
    }
}
export default App;
